import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=65b107bb&"
import script from "./Treatment.vue?vue&type=script&lang=ts&"
export * from "./Treatment.vue?vue&type=script&lang=ts&"
import style0 from "./Treatment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports